import React from 'react';
import HomeOwnerOnboardingDashboard from '../../components/HomeOwnerDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard/HomeOwnerOnboardingDashboard';
import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

const HomeOwnerOnboardingContainer = () => {
  return (
    <WithNavigation
      title="Dashboard"
      border
      top={<HomeOwnerOnboardingDashboard currentUserSuite={undefined} />}
    />
  );
};

export default HomeOwnerOnboardingContainer;